
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PsPosShiftControlViewDialog extends Serenity.EntityDialog<PsPosShiftControlViewRow, any> {
        protected getFormKey() { return PsPosShiftControlViewForm.formKey; }
        protected getIdProperty() { return PsPosShiftControlViewRow.idProperty; }
        protected getLocalTextPrefix() { return PsPosShiftControlViewRow.localTextPrefix; }
        protected getNameProperty() { return PsPosShiftControlViewRow.nameProperty; }
        protected getService() { return PsPosShiftControlViewService.baseUrl; }
        protected getDeletePermission() { return PsPosShiftControlViewRow.deletePermission; }
        protected getInsertPermission() { return PsPosShiftControlViewRow.insertPermission; }
        protected getUpdatePermission() { return PsPosShiftControlViewRow.updatePermission; }

        protected form = new PsPosShiftControlViewForm(this.idPrefix);

    }
}